export enum RewardLevelBenefit {
  FiveCentLabels = '_5_CENT_LABELS',
  ThreeCentLabels = '_3_CENT_LABELS',
  FundingDiscount = 'FUNDING_DISCOUNT',
  FreeShippingOver25 = 'FREE_SHIPPING_OVER_25',
  EarlyProductsAccess = 'EARLY_PRODUCTS_ACCESS',
  FreeLabelsPack = 'FREE_LABELS_PACK',
  ZeroCentLabels = '_0_CENT_LABELS',
  FreeShipping = 'FREE_SHIPPING',
  TwentyPercentOffAccessories = '_20_PERCENT_OFF_ACCESSORIES',
  VipSupport = 'VIP_SUPPORT',
  FreeFunding = 'FREE_FUNDING',
  ThirtyPercentOffAccessories = '_30_PERCENT_OFF_ACCESSORIES',
  VipPrinterPrice = 'VIP_PRINTER_PRICE',
  OnePercentCashback = '_1_PERCENT_CASHBACK',
}

export enum MarketplaceProvider {
  Amazon = 'Amazon',
  BigCartel = 'BigCartel',
  BigCommerce = 'BigCommerce',
  Cart3d = 'Cart3d',
  eBay = 'eBay',
  Ecwid = 'Ecwid',
  ETSY = 'ETSY',
  Magento = 'Magento',
  BestBuy = 'BestBuy',
  PayPal = 'PayPal',
  RolloApp = 'RolloApp',
  Shopify = 'Shopify',
  Squarespace = 'Squarespace',
  Square = 'Square',
  TikTok = 'TikTok',
  Walmart = 'Walmart',
  Wix = 'Wix',
  WooCommerce = 'WooCommerce',
}

export interface RewardLevelTimePeriodUnit {
  durationEstimated?: boolean;
  timeBased?: boolean;
  dateBased?: boolean;
}

export interface RewardLevelDto {
  id?: string;
  name: string;
  minShipments: number;
  minPoints?: number;
  timePeriod?: boolean;
  validFrom: string;
  validUntil: string | null;
  benefits?: RewardBenefitDto[];
  iconUrl?: string;
}

export interface RewardedActionDto {
  id?: string; // uuid
  title: string;
  description: string;
  iconUrl?: string;
  pointsAwarded: number;
  repeatable?: boolean;
  system?: boolean;
  type?: string;
  ctaUrl?: string;
  ctaText?: string;
  ctaId?: string;
  marketplaceProvider?: string;
}

export interface PagedRewardedActionDto {
  items?: RewardedActionDto[];
  total?: number;
  offset?: number;
}

export interface RewardBenefitDto {
  id?: string;
  title: string;
  description: string;
  systemType?: string | null;
  iconUrl?: string;
  levels?: RewardLevelDto['id'][];
}

export interface PagedRewardBenefitDto {
  items?: RewardBenefitDto[];
  total?: number;
  offset?: number;
}

export interface RewardBadgeActionDto {
  id?: string;
  name: string;
  title?: string;
}

export interface RewardBadgeDto {
  id?: string;
  title: string;
  description: string;
  notificationTitle?: string;
  notificationBody?: string;
  iconUrl?: string;
  shipmentBased?: boolean;
  minActionCount?: number;
  points?: number;
  actions?: RewardBadgeActionDto[];
}

export interface PagedRewardBadgeDto {
  items?: RewardBadgeDto[];
  total?: number;
  offset?: number;
}
